import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { getLocalStorageItem } from '../../../services/Helper';
import { historyPush, historyReplace } from '../../../services/History';
import { getErrorInfoDependsOfStatusCode, navigateToAppStore } from '../Constants';
import { IS_MOBILE_APP } from '../../../services/capacitor/Constants';
import image from '../../../images/illustrations/rectangular/404.svg';
import EmptyState from '../../emptyState/EmptyState';

const ErrorInfo = ({ clearError, errorStatusCode, isContentBlocking }) => {
	const { t } = useTranslation();

	const handleOnClick = () => {
		historyReplace('/');
		clearError && clearError();
	};

	const extraBtnOnClick = () => {
		historyPush('/');
	};

	const canUpgradeApp =
		IS_MOBILE_APP && errorStatusCode === 404 && getLocalStorageItem('userCanUpgradeApp');

	return (
		<div className="error-page">
			<EmptyState
				hideIcon
				image={image}
				title={
					canUpgradeApp
						? t('modals.upgrade_modal.title')
						: getErrorInfoDependsOfStatusCode(errorStatusCode, 'title', t)
				}
				description={
					canUpgradeApp
						? t('modals.upgrade_modal.description')
						: getErrorInfoDependsOfStatusCode(errorStatusCode, 'description', t)
				}
				btnTitle={
					canUpgradeApp
						? t('modals.upgrade_modal.btn_title')
						: getErrorInfoDependsOfStatusCode(errorStatusCode, 'back_to_home', t)
				}
				handleOnClick={canUpgradeApp ? navigateToAppStore : handleOnClick}
				showExtraBtn={canUpgradeApp}
				extraBtnTitle={t('modals.upgrade_modal.extra_btn_title')}
				extraBtnOnClick={extraBtnOnClick}
			/>
		</div>
	);
};

export default memo(ErrorInfo);
